var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-column",attrs:{"id":"app"}},[(!_vm.$route.meta.hideHeader)?_c('app-header'):_vm._e(),_c('div',{staticClass:"grow"},[_c('router-view')],1),_c('app-footer',{staticClass:"no-print"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }